import React from 'react'
import DocumentDialog, { DocumentSection } from '../DocumentDialog'

interface ISFFilingDialogProps {
  data: any
  onSave?: (updatedData: any, changes?: any[]) => void
  shipmentId: string
  documentId: string
}

const isfFilingSections: DocumentSection[] = [
  {
    id: 'documentInfo',
    title: 'Document Information',
    layout: 'double',
    fields: [
      { type: 'field', label: 'ISF Number', path: 'isfNumber' },
      { type: 'field', label: 'Bill of Lading Number', path: 'billOfLadingNumber' },
      { type: 'field', label: 'Filing Date', path: 'filingDate' },
      { type: 'field', label: 'Estimated Arrival Date', path: 'estimatedArrivalDate' },
    ],
  },
  {
    id: 'parties',
    title: 'Filing Parties',
    layout: 'single',
    fields: [
      {
        type: 'object',
        label: 'Importer',
        path: 'importer',
        fields: [
          { label: 'Name', path: 'name' },
          { label: 'Importer Number', path: 'importerNumber' },
          { label: 'Address', path: 'address' },
          { label: 'Contact', path: 'contact' },
        ],
      },
      {
        type: 'object',
        label: 'Supplier',
        path: 'supplier',
        fields: [
          { label: 'Name', path: 'name' },
          { label: 'Address', path: 'address' },
          { label: 'Contact', path: 'contact' },
        ],
      },
      {
        type: 'object',
        label: 'Manufacturer',
        path: 'manufacturer',
        fields: [
          { label: 'Name', path: 'name' },
          { label: 'Address', path: 'address' },
          { label: 'Contact', path: 'contact' },
        ],
      },
      {
        type: 'object',
        label: 'Seller',
        path: 'seller',
        fields: [
          { label: 'Name', path: 'name' },
          { label: 'Address', path: 'address' },
          { label: 'Contact', path: 'contact' },
        ],
      },
      {
        type: 'object',
        label: 'Buyer',
        path: 'buyer',
        fields: [
          { label: 'Name', path: 'name' },
          { label: 'Address', path: 'address' },
          { label: 'Contact', path: 'contact' },
        ],
      },
      {
        type: 'object',
        label: 'Ship To Party',
        path: 'shipToParty',
        fields: [
          { label: 'Name', path: 'name' },
          { label: 'Address', path: 'address' },
          { label: 'Contact', path: 'contact' },
        ],
      },
      {
        type: 'object',
        label: 'Consolidator',
        path: 'consolidator',
        fields: [
          { label: 'Name', path: 'name' },
          { label: 'Address', path: 'address' },
          { label: 'Contact', path: 'contact' },
        ],
      },
      {
        type: 'object',
        label: 'Stuffing Location',
        path: 'stuffingLocation',
        fields: [
          { label: 'Name', path: 'name' },
          { label: 'Address', path: 'address' },
        ],
      },
    ],
  },
  {
    id: 'vesselInfo',
    title: 'Vessel Information',
    layout: 'double',
    fields: [
      {
        type: 'object',
        label: 'Vessel',
        path: 'vessel',
        fields: [
          { label: 'Name', path: 'name' },
          { label: 'IMO Number', path: 'imoNumber' },
          { label: 'Voyage', path: 'voyage' },
        ],
      },
    ],
  },
  {
    id: 'locations',
    title: 'Locations',
    layout: 'double',
    fields: [
      { type: 'field', label: 'Port of Loading', path: 'portOfLoading' },
      { type: 'field', label: 'Port of Unlading', path: 'portOfUnlading' },
      { type: 'field', label: 'Country of Origin', path: 'countryOfOrigin' },
    ],
  },
  {
    id: 'containers',
    title: 'Containers',
    layout: 'single',
    fields: [
      {
        type: 'array',
        label: 'Containers',
        path: 'containers',
        columns: [
          { label: 'Container Number', path: 'number' },
          { label: 'Size', path: 'size' },
          { label: 'Type', path: 'type' },
          { label: 'Seal Number', path: 'sealNumber' },
        ],
      },
    ],
  },
  {
    id: 'cargo',
    title: 'Cargo Details',
    layout: 'single',
    fields: [
      {
        type: 'array',
        label: 'Cargo',
        path: 'cargo',
        columns: [
          { label: 'Description', path: 'description' },
          { label: 'HTS Number', path: 'htsNumber' },
          { label: 'Quantity', path: 'quantity' },
          { label: 'Quantity Unit', path: 'quantityUnit' },
          { label: 'Weight', path: 'weight', complexType: 'weight' },
          { label: 'Value', path: 'value', complexType: 'currency' },
        ],
      },
    ],
  },
  {
    id: 'additionalInfo',
    title: 'Additional Information',
    layout: 'single',
    fields: [
      { type: 'field', label: 'Special Instructions', path: 'specialInstructions', fullWidth: true },
    ],
  },
  {
    id: 'filingStatus',
    title: 'Filing Status',
    layout: 'double',
    fields: [
      { type: 'field', label: 'Status', path: 'status' },
      { type: 'field', label: 'Submission Date', path: 'submissionDate' },
      { type: 'field', label: 'Acceptance Date', path: 'acceptanceDate' },
    ],
  },
]

const ISFFilingDialog: React.FC<ISFFilingDialogProps> = ({
  data,
  onSave,
  shipmentId,
  documentId,
}) => {
  return (
    <DocumentDialog
      documentData={data}
      schema={{}} // TODO: Import isfFilingSchema from backend
      sections={isfFilingSections}
      documentType="ISF Filing"
      onSave={onSave}
      shipmentId={shipmentId}
      documentId={documentId}
    />
  )
}

export default ISFFilingDialog